import { Uuid } from "@/domains/global/identifiers";
import { resolveSyncModelNamespacedUuid } from "@/modules/uuid/sync-models/resolveSyncModelNamespacedUuid";
import { SyncModelKind } from "@/store/sync/types";

export const resolveSpaceAccountNoteSyncModelUuid = ({
  spaceAccountId,
  noteId,
}: {
  spaceAccountId: Uuid;
  noteId: Uuid;
}): Uuid => {
  return resolveSyncModelNamespacedUuid({
    modelKind: { value: SyncModelKind.SpaceAccountNote },
    uuids: [spaceAccountId, noteId],
  });
};
